export const GET_SYNCHRONIZATION_ERRORS_WATCHER = "GET_SYNCHRONIZATION_ERRORS_WATCHER";
export const GET_SYNCHRONIZATION_ERRORS_SUCCESS = "GET_SYNCHRONIZATION_ERRORS_SUCCESS";
export const GET_SYNCHRONIZATION_ERRORS_FAILED = "GET_SYNCHRONIZATION_ERRORS_FAILED";